import React from 'react';

import LoadingPlaceholder from 'components/new_ui/WaitLayers/LoadingPlaceholder';

export default function Wait() {
  return (
    <div className="content wallet">
      <section>
        <h1 className="mb-3">Wallet</h1>
      </section>
      <section>
        <LoadingPlaceholder text="Loading..." />
      </section>
    </div>

  );
}
